var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentPickingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    preserveAspectRatio: "xMidYMid",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#33B1F8",
    style: {
      stroke: "#2d3339",
      strokeWidth: 1,
      fillOpacity: 0.8
    },
    d: "M9 17.3c2-2.4 5.5-7.9 5.5-10.9 0-3.4-2.9-6-6-6s-6 2.6-6 6c0 3 3.6 8.5 5.5 10.9.3.3.7.3 1 0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0, 0, 0)",
    opacity: 0.4,
    d: "M8.5 4.5L6 8h1.5v3h2V8H11z"
  })), "undefined");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentPickingUp);
export default __webpack_public_path__ + "static/media/current_picking_up.15808ffdad0689a5d0b9b01f112e266b.svg";
export { ForwardRef as ReactComponent };